import { GetOrganizationSummaryResponseBodyType } from "@intelligems/ig-types/functions/organization-summaries/get-organization-summary";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { useGetOrg } from "../organizations/get-organization";
import { organizationsKeys } from "../queryKeys";

const getOrganizationSummary = async () => {
  const resp = await api.get<GetOrganizationSummaryResponseBodyType>(
    `/v2/organizations/subscriptions`
  );
  return resp.data;
};

export const useGetOrganizationSummaryWithLoading = () => {
  const org = useGetOrg();
  return useQuery<GetOrganizationSummaryResponseBodyType>({
    queryKey: organizationsKeys.orgSummary(org.data?.org?.id),
    queryFn: async () => getOrganizationSummary(),
    enabled: !!org.data?.org?.id,
    refetchOnWindowFocus: "always",
  });
};
